import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";

import { dataMetaSelector, deletePeopleBlockUser, dispatchGetEventPeopleBlock } from "Bands/state";
import { BAND_ACTIONS, IPeopleBlockUser } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";

const deleteUserCopy = copy.peopleBlock.delete;

interface DeletePeopleBlockUserModalProps {
  blockId: string;
  user: IPeopleBlockUser;
  handleClose: () => void;
}

export const DeletePeopleBlockUserModal: React.FC<DeletePeopleBlockUserModalProps> = ({
  blockId,
  user,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deletePeopleBlockUser));

  useClearActionMetaOnUnMount(BAND_ACTIONS.deletePeopleBlockUser);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      dispatchGetEventPeopleBlock(dispatch, blockId);

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteUserCopy.messages.success,
        })
      );
    }
  }, [dispatch, apiMeta, handleClose, blockId]);

  const handleDelete = () => {
    dispatch(deletePeopleBlockUser(user.id));
  };

  if (!user.user) return null;

  return (
    <DeleteModal
      type="user"
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
      name={`${user.user.firstname} ${user.user.lastname}`}
      dataTestId="delete_user_modal"
    ></DeleteModal>
  );
};
